import {
  Edit,
  CardActions,
  ListButton,
  RefreshButton,
  translate
} from "react-admin";
import React from "react";

import ProjectForm from "./ProjectForm";

const ProjectTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("project.project")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    {/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
    <RefreshButton />
  </CardActions>
);

const Title = translate(ProjectTitle);

export const ProjectEdit = props => (
  <Edit title={<Title />} actions={<Actions />} {...props}>
    <ProjectForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/project/ProjectEdit.js